module.exports = __webpack_public_path__ + "static/media/flexible-lg--image-2.d7194e62.jpg";